import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <div id="footer" className="text-center">
        <div className="title">
          <h6>Email</h6>
          <p>ladeolu2016@gmail.com</p>
        </div>
        <div className="title" id="middle">
          <h6>Contact</h6>
          <p>+234-813-6128-748</p>
        </div>
        <div className="title">
          <h6>Location</h6>
          <p>Lagos, Nigeria</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
